export const environment = {
	production: true,
  url: 'https://api.installer.kosaas-mmi.com:3002'
};
